import type { RuleSet } from 'styled-components';

import styled, { css } from 'styled-components';

import { CarouselTitle } from '../core/carousel/CarouselTitle';
import { colors, media } from '../core/styles';
import { SiteType } from '~/utilities/graphql/codegen';

export const CloseButton = styled.button`
  visibility: hidden;
  padding: 2px 10px;
  width: 40px;
  height: 40px;
  border: 2px solid transparent;

  &:focus-visible {
    border-color: ${colors.NERO_GREY};
  }
`;

const GStarRecommendationWrapperStyles = css`
  ${({ theme }) => css`
    @media ${({ theme }) => media(theme).greaterThan('lg')} {
      --recommendation-margin: ${theme.size['6']};
    }

    &.complete-the-look {
      @media ${({ theme }) => media(theme).greaterThan('sm')} {
        padding-inline: 32px;
      }
    }
  `}
`;

const AafRecommendationWrapperStyles = css`
  ${({ theme }) => css`
    --product-tile-info-height: 50px;

    @media ${({ theme }) => media(theme).greaterThan('lg')} {
      --recommendation-margin: ${theme.size['8']};
    }

    &.complete-the-look {
      @media ${({ theme }) => media(theme).greaterThan('sm')} {
        padding-inline: 20px;
      }
    }
  `}
`;

const RecommendationWrapperStylesConfig: Record<SiteType, RuleSet<object>> = {
  [SiteType.Gstar]: GStarRecommendationWrapperStyles,
  [SiteType.Wahts]: GStarRecommendationWrapperStyles,
  [SiteType.Outlet]: GStarRecommendationWrapperStyles,
  [SiteType.Employeeshop]: GStarRecommendationWrapperStyles,
  [SiteType.Aaf]: AafRecommendationWrapperStyles,
};

export const S = {
  RecommendationsWrapper: styled.div`
    ${({ theme }) => css`
      position: relative;
      display: block;

      --recommendation-margin: 0;

      margin-inline: 0 0;

      @media ${({ theme }) => media(theme).greaterThan('sm')} {
        --recommendation-margin: ${theme.size['4']};
      }

      ${RecommendationWrapperStylesConfig[theme.siteType]}
      &.complete-the-look {
        border-top: ${theme.borders.width.xs} solid
          ${theme.colors.border.component.accordion.separator};
        padding-inline: ${theme.padding.sm};

        @media ${media(theme).greaterThan('sm')} {
          --recommendation-margin: 0;
        }

        @media ${media(theme).greaterThan('lg')} {
          --recommendation-margin: 0;

          &[data-gallery-zoom-in='true'] {
            display: none;
          }
        }
      }

      .search-no-results & {
        margin-right: -${theme.padding['2xs']};

        @media ${media(theme).greaterThan('sm')} {
          margin-right: -${theme.padding.md};
        }

        --recommendation-margin: 0;
      }
    `}
  `,

  Title: styled(CarouselTitle)`
    ${({ theme }) => css`
      .complete-the-look & {
        padding: ${theme.padding.sm} ${theme.padding.none};
        font-size: ${theme.font.size[5]};
      }

      .search-no-results & {
        padding: ${theme.padding.lg} ${theme.padding.none} ${theme.padding.md};
      }
    `}
  `,
};
